import { reactive } from '@vue/reactivity'

const state = reactive({
    content: '',
})

export default state
